import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/white-site-logo-tlt.png';
const _hoisted_1 = {
  class: "site-login-page"
};
const _hoisted_2 = {
  class: "site-logo-tit"
};
const _hoisted_3 = {
  class: "panel-form-cnt"
};
const _hoisted_4 = {
  class: "panel-form-cnt-border"
};
const _hoisted_5 = {
  class: "form-header"
};
const _hoisted_6 = {
  class: "form-body"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_renderSlot(_ctx.$slots, "site-logo", {}, () => [_cache[0] || (_cache[0] = _createElementVNode("a", {
    href: "http://www.ijixiao.com"
  }, [_createElementVNode("img", {
    alt: "爱绩效",
    src: _imports_0
  })], -1))], true)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_renderSlot(_ctx.$slots, "header", {}, () => [_cache[1] || (_cache[1] = _createTextVNode("欢迎登录", -1))], true)]), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])])])]);
}